import axios from "axios";

const authClient = axios.create({
  baseURL: "/api/auth",
  timeout: 15000,
  withCredentials: true,
  withCredentials: true,
  headers: { Accept: "application/json" },
});

export const getAdminSession = async () => {
  const response = await authClient.get("/session");
  return response.data;
};

export const loginAdmin = async (username, password) => {
  const response = await authClient.post("/login", { username, password });
  return response.data;
};

export const logoutAdmin = async (csrfToken) => {
  const response = await authClient.post(
    "/logout",
    {},
    { headers: { "X-CSRF-Token": csrfToken } },
  );
  return response.data;
};
